import { useState } from 'react'

import { IgnoresScreen, shownError, syncIgnore, syncIgnores, syncUnignore, type DataKind, type ShownError } from '@krp/sync-ui'

import { queryState, useOperationIds, useSyncSources } from './syncKit'

/** «Не отслеживается» (RP-SYN8, требования 9, 16): список с возвратом и «не отслеживать вид данных у источника целиком». */
export function SyncIgnoresBinding() {
  const list = syncIgnores.useQuery()
  const { sources, nameOf } = useSyncSources()
  const { operationFor, settled } = useOperationIds()
  const [ignore] = syncIgnore.useMutation()
  const [unignore] = syncUnignore.useMutation()
  const [draftSource, setDraftSource] = useState('')
  const [draftKind, setDraftKind] = useState<DataKind>('item')
  const [addBusy, setAddBusy] = useState(false)
  const [addError, setAddError] = useState<ShownError | null>(null)
  const [busyIds, setBusyIds] = useState<ReadonlySet<number>>(() => new Set())
  const [rowErrors, setRowErrors] = useState<ReadonlyMap<number, ShownError>>(() => new Map())

  const add = () => {
    const intent = `ignore-source:${draftSource}:${draftKind}`
    setAddBusy(true)
    setAddError(null)
    void ignore({ operationId: operationFor(intent), level: 'source', resourceId: draftSource, dataKind: draftKind, remoteKey: null, productId: null, subject: null })
      .unwrap()
      .then(() => settled(intent))
      .catch((error: unknown) => setAddError(shownError('Не удалось перестать отслеживать', error)))
      .finally(() => setAddBusy(false))
  }

  const restore = (id: number) => {
    setBusyIds((current) => new Set(current).add(id))
    setRowErrors((current) => {
      const next = new Map(current)
      next.delete(id)
      return next
    })
    void unignore({ id })
      .unwrap()
      .catch((error: unknown) => setRowErrors((current) => new Map(current).set(id, shownError('Не удалось вернуть в сравнение', error))))
      .finally(() =>
        setBusyIds((current) => {
          const next = new Set(current)
          next.delete(id)
          return next
        }),
      )
  }

  const state = queryState(list, 'Не удалось получить список')
  return (
    <IgnoresScreen
      vm={{
        status: state.status,
        loadError: state.loadError,
        items: list.data ?? [],
        sources: sources.map((source) => ({ resourceId: source.resourceId, name: source.displayName })),
        nameOf,
        draftSource,
        draftKind,
        addBusy,
        addError,
        busyIds,
        rowErrors,
      }}
      actions={{ restore, draftSourceChanged: setDraftSource, draftKindChanged: setDraftKind, add, reload: () => void list.refetch() }}
    />
  )
}
